import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=2c41d85c&scoped=true&"
import script from "./NewsItem.vue?vue&type=script&scoped=true&lang=js&"
export * from "./NewsItem.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=2c41d85c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41d85c",
  null
  
)

export default component.exports